import CmbCompanySize from "./CmbCompanySize";

export default CmbCompanySize